// resource-management.module.js
const _state = {
  slides: {},
  presentations: {},
}

const actions = {
  getResourceByIdAction: async ({ dispatch }, payload) => {
    dispatch('kvSync/fetchValueByKeyAction', {
      key: `/${payload.resourceName}/${payload.resourceId}`,
    }, { root: true })
  },
  updateResourceByIdAction: async ({ commit }, payload) => {
    commit('updateResourceById', payload)
  },

  setResourceByIdAction: async ({ commit }, payload) => {
    commit('setResourceById', payload)
  },
}

const mutations = {
  setResourceById(state, payload) {
    const { resourceName, resourceId, resourceValue } = payload
    if (!state[resourceName]) {
      state[resourceName] = {}
    }

    state[resourceName][resourceId] = resourceValue
  },
  updateResourceById(state, payload) {
    const {
      resourceName, resourceId, propertyName, propertyValue,
    } = payload
    if (!state[resourceName]) {
      state[resourceName] = {}
    }
    if (!state[resourceName][resourceId]) {
      state[resourceName][resourceId] = {
        [propertyName]: propertyValue,
      }
    } else {
      state[resourceName][resourceId] = {
        ...state[resourceName][resourceId],
        [propertyName]: propertyValue,
      }
    }
  },
}

const getters = {
  resourceById: (state) => (resourceName, resourceId) => {
    if (!state[resourceName]) {
      return null
    }
    return state[resourceName][resourceId]
  },
}

export default {
  namespaced: true,
  state: _state,
  actions,
  mutations,
  getters,
}
